function parseMadesaBuyNowI18n() {
  const defaults = {
    activating_coupon: 'Applying coupon...',
    adding_to_cart: 'Adding to cart...',
  };
  const el = document.getElementById('madesa-buy-now-i18n');
  if (!el || !String(el.textContent || '').trim()) {
    return defaults;
  }
  try {
    const parsed = JSON.parse(el.textContent);
    return {
      activating_coupon:
        parsed.activating_coupon != null && parsed.activating_coupon !== ''
          ? parsed.activating_coupon
          : defaults.activating_coupon,
      adding_to_cart:
        parsed.adding_to_cart != null && parsed.adding_to_cart !== ''
          ? parsed.adding_to_cart
          : defaults.adding_to_cart,
    };
  } catch (e) {
    return defaults;
  }
}

const MadesaBuyNowI18n = parseMadesaBuyNowI18n();

/** Alinhado ao add-to-cart (~800ms) para o checkmark burst completar */
const SUCCESS_ANIMATION_MS = 780;

class MadesaBuyNow extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.labelWrap = this.querySelector('.add-to-cart-text');
    this.labelEl = this.querySelector('[data-ref="label"]');
    this.statusEl = this.querySelector('[data-ref="status"]');
    this.successEl = this.querySelector('[data-ref="success"]');
    this.defaultLabel =
      this.button?.dataset.defaultLabel ||
      (this.labelEl && this.labelEl.textContent ? this.labelEl.textContent.trim() : '');
    this.isBusy = false;
  }

  connectedCallback() {
    this._onClick = this.handleClick.bind(this);
    this.button?.addEventListener('click', this._onClick);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this._onClick);
  }

  hasCouponIntent() {
    return (
      typeof window.madesaHasPdpCouponIntent === 'function' &&
      window.madesaHasPdpCouponIntent()
    );
  }

  setCouponBusyState(message) {
    if (!this.button) return;
    this.isBusy = true;
    this.button.disabled = true;
    this.button.classList.add('madesa-buy-now-btn--busy', 'madesa-buy-now-btn--coupon-flow');
    this.button.removeAttribute('data-added');

    if (this.labelWrap) {
      this.labelWrap.setAttribute('aria-hidden', 'true');
      this.labelWrap.classList.add('madesa-buy-now__label--hidden');
    }
    if (this.statusEl) {
      this.statusEl.textContent = message;
      this.statusEl.hidden = false;
    }
    if (this.successEl) {
      this.successEl.hidden = true;
    }
  }

  resetButtonState() {
    if (!this.button) return;
    this.isBusy = false;

    const productForm = this.closest('product-form-component, product-form');
    const brindeBlocked =
      productForm instanceof HTMLElement &&
      productForm.dataset.isBrinde === 'true' &&
      window.MadesaBrinde?.isAddLocked?.();

    this.button.disabled = !!brindeBlocked;
    this.button.classList.toggle('madesa-brinde-btn--blocked', !!brindeBlocked);
    if (brindeBlocked) {
      this.button.setAttribute('aria-disabled', 'true');
    } else {
      this.button.removeAttribute('aria-disabled');
    }
    this.button.classList.remove('madesa-buy-now-btn--busy', 'madesa-buy-now-btn--coupon-flow');
    this.button.removeAttribute('data-added');

    if (this.labelWrap) {
      this.labelWrap.removeAttribute('aria-hidden');
      this.labelWrap.classList.remove('madesa-buy-now__label--hidden');
    }
    if (this.labelEl) {
      this.labelEl.textContent = this.defaultLabel;
    }
    if (this.statusEl) {
      this.statusEl.textContent = '';
      this.statusEl.hidden = true;
    }
    if (this.successEl) {
      this.successEl.hidden = true;
    }
  }

  playSuccessAnimation() {
    if (!this.button) return Promise.resolve();

    this.button.classList.remove('madesa-buy-now-btn--busy', 'madesa-buy-now-btn--coupon-flow');
    if (this.statusEl) {
      this.statusEl.hidden = true;
    }
    if (this.labelWrap) {
      this.labelWrap.removeAttribute('aria-hidden');
      this.labelWrap.classList.remove('madesa-buy-now__label--hidden');
    }
    if (this.successEl) {
      this.successEl.hidden = false;
    }

    this.button.setAttribute('data-added', 'true');

    return new Promise((resolve) => {
      window.setTimeout(resolve, SUCCESS_ANIMATION_MS);
    });
  }

  getCartUrl() {
    const shopRoot =
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';
    return shopRoot === '/' ? '/cart' : shopRoot.replace(/\/$/, '') + '/cart';
  }

  async resolveDiscountCode() {
    let code =
      typeof window.madesaGetDiscountCookieCode === 'function'
        ? window.madesaGetDiscountCookieCode()
        : '';

    if (code) return code;

    this.setCouponBusyState(MadesaBuyNowI18n.activating_coupon);

    if (typeof window.madesaWaitForDiscountCode === 'function') {
      code = await window.madesaWaitForDiscountCode({
        maxWait: 1800,
        interval: 50,
      });
    }

    return code || '';
  }

  async handleClick(event) {
    event.preventDefault();
    if (this.isBusy || !this.button) return;

    const productForm = this.closest('product-form-component, product-form');
    const isBrinde =
      productForm instanceof HTMLElement && productForm.dataset.isBrinde === 'true';
    const brinde = window.MadesaBrinde;

    if (isBrinde && brinde?.isAddLocked?.()) {
      brinde.showError('already_in_cart');
      return;
    }

    const couponIntent = this.hasCouponIntent();

    try {
      const variantId = this.getSelectedVariantId();

      if (!variantId) {
        console.error('Não foi possível identificar a variant selecionada.');
        return;
      }

      if (isBrinde) {
        if (!brinde?.tryBeginBrindeAdd?.()) {
          brinde?.showError?.('already_in_cart');
          return;
        }

        this.button.disabled = true;

        const productId = Number(
          productForm instanceof HTMLElement ? productForm.dataset.productId : 0
        );
        const brindeResult = brinde?.confirmBrindeAdd
          ? await brinde.confirmBrindeAdd({ productId, variantId })
          : { ok: true };

        if (!brindeResult.ok) {
          brinde?.showError?.(brindeResult.reason || 'already_in_cart');
          this.resetButtonState();
          return;
        }
      }

      if (couponIntent) {
        this.setCouponBusyState(MadesaBuyNowI18n.adding_to_cart);
      } else if (!isBrinde) {
        this.button.disabled = true;
      }

      const payload = {
        items: [
          {
            id: Number(variantId),
            quantity: 1,
            ...(isBrinde ? { properties: { _brinde: 'true' } } : {}),
          },
        ],
      };
      const root =
        window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/';

      const res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        console.error('Falha ao adicionar ao carrinho:', await res.text());
        if (isBrinde) {
          brinde?.releaseBrindeAddFailed?.();
        }
        this.resetButtonState();
        return;
      }

      if (isBrinde) {
        brinde?.releaseBrindeAddSuccess?.(
          productForm instanceof HTMLElement ? productForm.dataset.productId : undefined,
          variantId
        );
      }

      let discountCode = '';

      if (couponIntent) {
        discountCode = await this.resolveDiscountCode();
        if (discountCode) {
          this.setCouponBusyState(MadesaBuyNowI18n.activating_coupon);
        }
      }

      await this.playSuccessAnimation();

      if (
        couponIntent &&
        discountCode &&
        typeof window.madesaGetCartDiscountRedirectUrl === 'function'
      ) {
        window.location.href =
          window.madesaGetCartDiscountRedirectUrl(discountCode);
        return;
      }

      window.location.href = this.getCartUrl();
    } catch (e) {
      console.error('Erro no Comprar agora:', e);
      if (isBrinde) {
        window.MadesaBrinde?.releaseBrindeAddFailed?.();
      }
      this.resetButtonState();
    }
  }

  getSelectedVariantId() {
    const variantInput = document.querySelector(
      'form[action*="/cart/add"] [name="id"]'
    );
    if (variantInput) {
      return variantInput.value;
    }

    const productForm = this.closest('product-form-component, product-form');
    if (productForm) {
      const variantIdInput = productForm.querySelector('[name="id"]');
      return variantIdInput?.value;
    }

    return null;
  }
}

if (!customElements.get('madesa-buy-now')) {
  customElements.define('madesa-buy-now', MadesaBuyNow);
}
